import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

class TagGroup extends Component {
  constructor (props) {
    super(props)
    this._setInitialTagValue(props.field.value)

    this.state = { tags: [] }

    this.handleChange = this.handleChange.bind(this)
  }

    componentWillReceiveProps = nextProps => {
      let fieldValue = nextProps.field.value
      if (typeof (fieldValue) === 'string') {
        fieldValue = fieldValue === '' ? [] : fieldValue.split(';')
      }
      this._setInitialTagValue(fieldValue)
    }

    _setInitialTagValue = fieldValue => {
      const initialTags = fieldValue || []
      const validTags = initialTags.filter(tag => tag !== '\\')
      this.state = {
        tags: validTags
      }
    }

    handleChange (tags, field) {
      const validTags = tags.filter(tag => tag !== '\\')
      this.setState({ tags: validTags }, function () {
        var event = {}
        event.preventDefault = () => { }

        event.target = {
          value: this.state.tags.length === 0 ? '' : this.state.tags.join(';')
        }

        this.props.validate(event, field)
      })
    }

    addTag = tags => {
      this.updateTags(tags)
    }

    updateTags = tags => {
      const validTags = tags.filter(tag => tag !== '\\')

      this.setState({ tags: validTags })
    }

    _reset = () => {
      this.setState({
        tags: []
      })
    }

    _overriddenRenderLayout = (tagComponents, inputComponent) => {
      return (
        <div>
          <div>{inputComponent}</div>
          <div className='admin-adgroup-tag'>
            <span>{tagComponents}</span>
          </div>
        </div>
      )
    }

    _defaultRenderLayout = (tagComponents, inputComponent) => {
      return (
        <span>
          {tagComponents}
          {inputComponent}
        </span>
      )
    }

    render () {
      const { field, overrideLayout = false, onlyUnique = false, removeKeys = [8] } = this.props
      const required = ((field.rules.required !== undefined) && (field.rules.required.required === true || field.rules.required.required !== false))
      field.errors = field.errors || []
      const hasErrors = field.errors.length > 0

      return (
        <div className={hasErrors ? 'form-group has-danger' : 'form-group'}>
          {field.rules.title !== '' &&
            <label className='form-control-label tag-label'>{field.rules.title + (required ? '*' : '')}</label>}
          <TagsInput
            value={this.state.tags}
            maxTags={-1}
            addOnBlur
            inputProps={{ placeholder: this.props.placeholder || '' }}
            onlyUnique={onlyUnique}
            removeKeys={removeKeys}
            renderLayout={overrideLayout ? this._overriddenRenderLayout : this._defaultRenderLayout}
            onChange={tags => this.handleChange(tags, field)}
          />

          {field.errors.map((error, i) =>
            <div key={i} className='form-control-feedback'>{error}</div>
          )}
        </div>
      )
    }
}
export default TagGroup



// WEBPACK FOOTER //
// ./src/forms/TagGroup.js